import { Divider, Popper } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { Text } from "../Base";
import { View } from "../View";
import { palette } from "../../theme/palette";
import { CloseIcon } from "../Icons/Close";

const useStyles = makeStyles({
  popupContainer: {
    position: "fixed",
    top: 0,
    left: 0,
    height: "100vh",
    width: "100vw",
    background: "transparent",
    zIndex: "1400 !important",
  },
  popup: {
    display: "flex",
    flexDirection: "row",
    color: palette.white,
    maxHeight: "280px",
    paddingBottom: "50px",
    paddingRight: "5px",
    zIndex: "1400 !important",
    borderColor: palette.typography.black.high,
  },
  popupPaper: {
    display: "flex",
    backgroundColor: "transparent",
    boxShadow: "none",
    borderRadius: "10px",
    marginTop: "-1rem",
  },
  popupContents: {
    color: palette.white,
    width: "240px",
    maxHeight: "255px",
    background: palette.lowTranslucentTrueBlack,
    padding: "10px 10px 15px 10px",
    borderRadius: "10px",
  },
  detailsContainerTopRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    fontSize: "18px",
  },
  detailsContainerCloseIcon: {
    height: "12px",
    cursor: "pointer",
  },
  postcode: {
    fontSize: "16px",
  },
  postcodeSpace: {
    height: "8px",
  },
  route: {
    fontSize: "18px",
    marginTop: "10px",
    marginBottom: "0px",
    color: palette.sunburst,
  },
  pickupListItem: {
    fontSize: "12px",
  },
  detailsContainerDivider: {
    background: palette.translucentWhite,
  },
  pickupList: {
    overflow: "scroll",
    margin: "0px",
    maxHeight: "240px",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  arrowContainer: {
    marginLeft: "5px",
    marginTop: "10px",
  },
  arrow: {
    width: "0",
    height: "0",
    borderTop: "5px solid transparent",
    borderBottom: "5px solid transparent",
    borderRight: `10px solid ${palette.lowTranslucentTrueBlack}`,
  },
});

export const PickupPopup = ({ anchorEl, pickupConfig, onClose }) => {
  const styles = useStyles();

  const renderPickupList = () => {
    const { routeCodes, popupLabels } = pickupConfig;

    return routeCodes
      .map((routeCode) => {
        const routeLabels = popupLabels[routeCode];
        if (!routeLabels) return [];

        const routeComponents = [
          <Text
            key={`${routeCode}`}
            className={styles.route}
          >{`Route ${routeCode}`}</Text>,
        ];

        Object.entries(routeLabels).forEach(
          ([postcode, postcodeLabel], index) => {
            index &&
              routeComponents.push(
                <View
                  key={`${routeCode}-${postcode}-space`}
                  className={styles.postcodeSpace}
                />
              );
            routeComponents.push(
              <Text
                key={`${routeCode}-${postcode}`}
                className={styles.postcode}
              >
                {postcode}
              </Text>
            );
            routeComponents.push(
              <Text
                key={`${routeCode}-${postcode}-partnerLabel`}
                className={styles.pickupListItem}
              >
                {postcodeLabel}
              </Text>
            );
          }
        );
        return routeComponents;
      })
      .flatMap((components) => components);
  };

  return (
    !!anchorEl && (
      <View
        className={styles.popupContainer}
        onWheel={(e) => {
          e.stopPropagation();
          onClose();
        }}
        onClick={(e) => {
          e.stopPropagation();
          onClose();
        }}
      >
        <Popper
          className={styles.popup}
          open={!!anchorEl}
          anchorEl={anchorEl}
          placement={"right-start"}
          onWheel={(e) => e.stopPropagation()}
          onClick={(e) => e.stopPropagation()}
        >
          <View className={styles.arrowContainer}>
            <View className={styles.arrow} />
          </View>
          <View
            className={styles.popupContents}
            onWheel={(e) => e.stopPropagation()}
            onClick={(e) => e.stopPropagation()}
          >
            <View className={styles.detailsContainerTopRow}>
              <Text>Pickup</Text>
              <CloseIcon
                role="button"
                onClick={() => {
                  onClose();
                }}
                className={styles.detailsContainerCloseIcon}
              />
            </View>
            <Divider className={styles.detailsContainerDivider} light={true} />
            <View className={styles.pickupList}>{renderPickupList()}</View>
          </View>
        </Popper>
      </View>
    )
  );
};
